import {i18n} from '@/plugins/i18n'

export const walletReportType = {
    STATEMENT: 1,
    PAYA: 2,
};

export const walletReportTypeStr = {
    STATEMENT: i18n.t('wallets.label.statement-report'),
    PAYA: i18n.t('wallets.label.paya-report'),

    get(type) {
        let str = null;

        Object.keys(walletReportType).forEach(item => {
            if (walletReportType[item] === type) {
                str = walletReportTypeStr[item];
            }
        });

        return str;
    }
};
